import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import SocialShareComponent from '../../shared/SocialShare/social.share.vue';
import moment from 'moment';
import { News } from '../../models/news.model';

@Component({
    components: {
        SocialShareComponent
    }
})
export default class EpicNewsCard extends Vue {
    public title: string = 'EpicNewsCard';
    public dateFormated!: string;
    public brief: string = '';
    public categoryMap: any = {
        'rifo web real estate': {
            name: 'Real Estate',
            key: 'rifo_web_real_estate'
        },
        'rifo web finance': {
            name: 'Finance',
            key: 'rifo_web_finance'
        },
        'rifo web event': {
            name: 'Event',
            key: 'rifo_web_event'
        },
        'rifo web explore': {
            name: 'Explore',
            key: 'rifo_web_explore'
        },
        'rifo web story': {
            name: 'Story',
            key: 'rifo_web_story'
        },
    };
    @Prop({ default: function(): News {
        return {
            id: '1727',
            images: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/test-big-news.png',
            title: 'Yes, Canadian rom-coms are their own thing — and they say more about us than you might think',
            detail: 'No matter whether you are house buyer or renter, We aim at build find the right',
            customized_author_name: 'Wang Ting',
            createdat: new Date().getTime(),
            createdatStr: 'Fri Jul 19 06:39:06 UTC 2019',
            browseCount: 2234,
            tags: ['Event'],
            source: 'blog'
        };
    } })
    public data!: null| News;
    public tags: any = null;

    @Prop({
        default: false
    })
    public column!: boolean;
    @Prop({
        default: false
    })
    public hideBrief!: boolean;
    @Prop({
        default: false
    })
    public share!: boolean;

    @Prop({
        default: ''
    })
    public prefix!: boolean;

    @Watch('data.createdatStr', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
        this.dateFormated = moment(String(val)).format('YYYY-MM-DD');
    }

    @Watch('data.detail', { immediate: true, deep: true })
    public createdDetail(val: any, oldVal: any) {
        const span = document.createElement('span');
        span.innerHTML = val;
        const content = (span.textContent || span.innerText);
        this.brief = content.length > 50
            ? content.slice(0, 200) + '...'
            : content;
    }

    @Watch('data.catagoryList', { immediate: true, deep: true })
    public createdTags(val: any, oldVal: any) {
        if (val) {
            const TagRawList = val.split(', ');
            if (TagRawList && TagRawList.length) {
                const self = this;
                this.tags = TagRawList.map((v: string) => {
                    if (self.categoryMap[v]) {
                        return self.categoryMap[v];
                    } else {
                        return null;
                    }
                }).filter((v: any) => !!v);
            }
        }

    }
    public goDetail(e: Event) {
        if (this.data) {
            this.$router.push(this.prefix + '/news-detail/' + this.data.source + '/' + this.data.id);
        }
    }
    public goNews(type: string) {
        this.$router.push('/news-list/' + type);
    }
}
